import _ from 'lodash'
import moment from 'moment'
import { req } from '@/api/api_request'

// 超标浓度高 小时、周
export function edfData1(type, line_t) {
  console.log(type, line_t);
  let tm = moment(line_t).format('YYYY-MM-DDTHH')
  let url = `http://jnwz.novaecs.com/mapi/edf_sources/levels_latest_date/${tm}`
  if (type === 'week') {
    tm = moment(line_t).format('YYYY-MM-DD')
    url = `http://jnwz.novaecs.com/mapi/edf_sources/levels_pastweek_date/${tm}`
  }
  // 截取前50
  return req.get(url)
}

// 超限值小时数多 周
export function edfData2(line_t) {
  let tm = moment(line_t).format('YYYY-MM-DD')
  let url = `http://jnwz.novaecs.com/mapi/edf_sources/threshold_pastweek_date/${tm}`
  // 截取前50
  return req.get(url)
}

// 同比反弹幅度大
export function edfData3() {
  let url = `http://jnwz.novaecs.com/mapi/edf_sources/yearly_increase`
  return req.get(url)
}

// 前期上升快后期慢
export function edfData4() {
  let url = `http://jnwz.novaecs.com/mapi/edf_sources/trend_sources`
  return req.get(url)
}


// 网格列表
export async function edfData5() {
  let url = `http://jnwz.novaecs.com/mapi/edf_sources/latest_all`
  let res = await req.get(url)

  let grids = []
  for (let idx in res.data.lattitude) {
    grids.push([res.data.longitude[idx], res.data.lattitude[idx]])
  }
  return {data: {pm10: {grid_coords: grids}}}
}


// WEBPACK FOOTER //
// ./src/components/edf/api.js